<template>
  <div>
    <h1>AES加密解密</h1>
    <el-form :model="form" label-width="120px" style="max-width: 600px; margin-top: 20px;">
      <el-form-item label="密码">
        <el-input v-model="form.passwd" show-password placeholder="请输入密码" clearable></el-input>
      </el-form-item>
      <el-form-item label="目标字符串">
        <el-input v-model="form.str" type="textarea" :rows="3" placeholder="请输入要加密的字符串"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </el-form-item>
    </el-form>

    <el-card style="max-width: 600px; margin-top: 20px;">
      <div slot="header">
        <span>对目标字符串分别加解密</span>
      </div>
      <div>
        <p><strong>加密结果：</strong></p>
        <el-input type="textarea" :rows="3" :value="result?.encryptHex || ''" readonly></el-input>
        <p style="margin-top: 20px;"><strong>解密结果：</strong></p>
        <el-input type="textarea" :rows="3" :value="result?.decryptStr || ''" readonly></el-input>
      </div>
    </el-card>
  </div>
</template>

<script>
import {aesSubmitFn} from '@/apis/menuAesApi'

export default {
  name: "MenuAes",
  components: {},
  data() {
    return {
      form: {
        passwd: '',
        str: ''
      },
      result: null
    }
  },
  methods: {
    submitForm() {
      if (!this.form.passwd || !this.form.str) {
        this.$message.warning('请填写完整信息')
        return
      }
      aesSubmitFn(this.form).then(res => {
        if (res.success) {
          this.result = res.data
        } else {
          this.$message.error(res.msg || '操作失败')
          this.result = null
        }
      }).catch(err => {
        this.$message.error(err.message || '操作失败')
        this.result = null
      })
    }
  },
  watch: {
    // 'searchParamVo.topPath': {handler: function (val, oldVal) {if (val) {this.searchParamVo.topPath = val;this.searchParamVo.topPath = '';}}, deep: true},
  },// watch
  mounted() {
    // this.init();
  },// mounted
}
</script>

<style scoped>
</style>